import { px } from "csx";
import { Content } from "gls";
import { FC } from "react";
import { classes, style } from "typestyle";
import logo from "../../assets/images/logo.png";
import logoCollapsed from "../../assets/images/logoCollapsed.png";

interface LogoProps {
  isCollapsed?: boolean;
  height?: number;
  className?: string;
}

export const Logo: FC<LogoProps> = ({ isCollapsed, height, className }) => {
  return (
    <Content>
      <img
        src={logoCollapsed}
        alt="observe tech's logo"
        className={classes(
          style({
            height: px(height || 25),
            display: isCollapsed ? "block" : "none",
          }),
          className,
        )}
      />
      <img
        src={logo}
        alt="observe tech's logo"
        className={classes(
          style({
            height: px(height || 34),
            display: !isCollapsed ? "block" : "none",
          }),
          className,
        )}
      />
    </Content>
  );
};
